// Form initial values

export const jobAddressValues = {
    sameAddress: '',
    pais: '',
    nombrePais: '',
    descDireccion: '',
    entidad:'',
    ciudad: '',
    municipio: '',
    parroquia: '',
    urbanizacion: '',
    avenida: '',
    tipoInmueble: '',
    nombreInmueble: '',
    torre: '',
    piso: '',
    edificio: '',
    oficina: '',
    apartamento: '',
    local: '',
    callecarretera: '',
    calle: '',
    esquina: '',
    observaciones: '',
    telefono1: {
        codigoArea: "",
        descripcionTipoDireccion: 0,
        identificador: 1,
        numero: "",
        tipo: "",
        tipoDireccion: "D",
    }
}

export const initialValues = {
    // hasJob: '',
    jobReferences: {
        // sameAddress: '',
        // constancy: '',
        hasLevelOneAccount: '',
        tipoCliente: '',
        hasJob: '',
        empleo: {
            address: {
                ...jobAddressValues,
                sameAddress: 'no',
            },
            fechaConsIng: '',
            rifType: '',
            rif: '',
            sueldoMensual: '',
            moneda: '',
            otraMoneda: '',
            tipoContrato: '',
            nombreEmpresa: '',
            cargo: '',
            fechaIngreso: '',
            rol: '',
            email: '',
            ramo: '',
            sueldoBonificacion: '',
            constancy: ''
        },
        hasIncome: '',
        ingreso: {
            address: jobAddressValues,
            fechaConsIng: '',
            montoEstimado: '',
            moneda: '',
            email: '',
            otrosIngresos: '',
            constancy: '',
        },
        hasBusiness: '',
        negocioPropio: {
            address: jobAddressValues,
            fechaConstitutiva: '',
            rifType: '',
            rif: '',
            nombreNegocio: '',
            numeroNegocio: '',
            datosRegistro: '',
            folio: '',
            libro: '',
            moneda: '',
            email: '',
            ramo: '',
            ingresos: '',
            constancy: '',
            businessSuppliers: [
                {
                    searchedOnList: false,
                    isOnList: false,
                    nombreCompleto: '',
                    pais: '',
                    entidad: '',
                    telefono: '',
                    tipo: 'P'
                }
            ],
            businessClients: [
                {
                    searchedOnList: false,
                    isOnList: false,
                    nombreCompleto: '',
                    pais: '',
                    entidad: '',
                    telefono: '',
                    tipo: 'C'
                }
            ]
        },
    }
};